<div class="page-layout carded fullwidth" *ngIf="existeSujetoObligado">
    <mat-drawer-container class="overlay-container page-layout carded fullwidth" >

        <filtros-dd [(filtro)]="filterForm" [sujetoObligado]="this.sujetoObligado" (loadData)="loadData()" (filterChange)="filterForm=$event"></filtros-dd>
        <!-- CENTER -->
        <div class="center">

        <!-- CONTENT HEADER -->
        <div
            class="header accent p-24"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <h2 class="m-0">
                <span *ngIf="!editar_nombre" class="px-20"
                    >Sujeto obligado</span
                >
                <input
                    placeholder="Nombre"
                    matInput
                    [(ngModel)]="nombre"
                    *ngIf="editar_nombre"
                />
                <mat-icon
                    *ngIf="editar_nombre"
                    aria-hidden="false"
                    aria-label="Editar estado"
                    (click)="updateName(nombre)"
                    >save</mat-icon
                >
                <mat-icon
                    *ngIf="is_eval_creador"
                    aria-hidden="false"
                    aria-label="Editar nombre"
                    (click)="editar_nombre = true"
                    >edit</mat-icon
                >
            </h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="toolbar px-24 py-8">
                <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                    <!--<button
                        mat-button
                        (click)="print()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="print"
                            >print</mat-icon
                        >
                    </button>-->

                    <button
                        mat-button
                        (click)="back()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="Salir"
                            >exit_to_app</mat-icon
                        >
                        Salir
                    </button>
                </div>
            </div>

            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" style="max-height: 200px !important">
                <div id="scan" class="p-24" fxLayout="row" xFlex="100">
                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr class="code">
                                    <td class="label">Nombre</td>
                                    <td class="value">
                                        <span class="px-20">{{
                                            sujetoObligado?.nombre
                                        }}</span>
                                    </td>
                                </tr>
                                <!--
                                <tr class="code">
                                    <td class="label">Sector de Actividad</td>
                                    <td class="value">
                                        <span class="px-20">{{
                                            sujetoObligado?.sectorIndustrial
                                                ?.nombre
                                        }}</span>
                                    </td>
                                </tr>-->

                                <tr class="code">
                                    <td class="label">Tipo</td>
                                    <td class="value">
                                        <span class="px-20"
                                            >{{
                                                sujetoObligado
                                                    ?.tipoSujetoObligado
                                                    ?.nombre
                                            }},
                                            {{
                                                sujetoObligado
                                                    ?.tipoSujetoObligado?.tipo
                                                    | translate
                                            }}
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr>
                                    <td class="label">Documento</td>
                                    <td class="value">
                                        <span class="px-20"
                                            >{{
                                                sujetoObligado?.razonSocial
                                                    ?.tipo?.nombre
                                            }}
                                            |
                                            {{
                                                sujetoObligado?.razonSocial
                                                    ?.numero
                                            }}</span
                                        >
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- / CONTENT -->

            <!-- TABS -->

            <div class="content">
                <mat-tab-group dynamicHeight>
                    <mat-tab
                        label="Representantes"
                    >
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    mat-button
                                    (click)="
                                        openDialogRepresentantes('Add', {})
                                    "
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Nuevo representante
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="
                                        sujetoObligado?.representantes
                                    "
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                 The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="nombre">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nombre.
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nombreCompleto }}
                                        </td>
                                    </ng-container>

                                    <!-- Role Column -->
                                    <ng-container
                                        matColumnDef="correoElectronico"
                                    >
                                        <th mat-header-cell *matHeaderCellDef>
                                            Correo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.correoElectronico }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acciones
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <a
                                                (click)="
                                                    openDialogRepresentantes(
                                                        'View',
                                                        element
                                                    )
                                                "
                                                >Ver</a
                                            >
                                            |
                                            <a
                                                (click)="
                                                    openDialogRepresentantes(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                >Editar</a
                                            >
                                            |
                                            <a
                                                (click)="
                                                    openDialogRepresentantes(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                >Eliminar</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsRepresentantes
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsRepresentantes
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>
                </mat-tab-group>
            </div>

            <div class="content">
                <mat-tab-group dynamicHeight>
                    <mat-tab label="Operaciones">
                        <div
                            class="widget-group p-12"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    mat-button
                                    (click)="openDialogDD('Add', {})"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Nueva operación
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="debidasDiligencias"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                   The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="estado">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Estado
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.estado }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cliente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Cliente
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.cliente?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="vencimiento">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Vencimiento
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.fechaVencimiento
                                                    | date : "dd/MM/yyyy"
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="beneficiario">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Beneficiario
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nombreBeneficiario }}
                                        </td>
                                    </ng-container>

                                    <ng-container
                                        matColumnDef="sectorIndustrial"
                                    >
                                        <th mat-header-cell *matHeaderCellDef>
                                            Sector de actividad
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.sectorIndustrial?.nombre
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="tipo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Tipo de operación
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.tipoOperacion?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acciones
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    navegateToDD(
                                                        '/debida-diligencia',
                                                        element.uuid
                                                    )
                                                "
                                                >Ver</a
                                            >
                                            |
                                            <a
                                                (click)="
                                                    openDialogDD(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                >Editar</a
                                            >
                                            |
                                            <!-- <a (click)="navegateToDD('/debida-diligencia',element.uuid)">Solicitud de informacion</a>
                                  |
                                  <a (click)="openDialogDD('Delete',element)">Debida diligencia</a>
                                  | -->
                                            <a
                                                (click)="
                                                    openDialogDD(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                >Eliminar</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsOperaciones
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsOperaciones
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab label="Clientes">
                        <div
                            class="widget-group p-12"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    mat-button
                                    (click)="openDialogClientes('Add', {})"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Nuevo cliente
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="clientes"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="tipo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Tipo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.tipo }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nombre">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nombre
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nombre }}
                                        </td>
                                    </ng-container>

                                    <!-- Role Column -->
                                    <ng-container matColumnDef="razonSocial">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Documento
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.razonSocial?.tipo
                                                    ?.nombre
                                            }}
                                            |
                                            {{ element.razonSocial?.numero }}
                                        </td>
                                    </ng-container>

                                    <ng-container
                                        matColumnDef="sectorIndustrial"
                                    >
                                        <th mat-header-cell *matHeaderCellDef>
                                            Sector de actividad
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.sectorIndustrial?.nombre
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acciones
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <a
                                                (click)="
                                                    navegateTo(
                                                        '/cliente',
                                                        element.id
                                                    )
                                                "
                                                >Ver</a
                                            >
                                            |
                                            <a
                                                (click)="
                                                    openDialogClientes(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                >Editar</a
                                            >
                                            |
                                            <a
                                                (click)="
                                                    openDialogClientes(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                >Eliminar</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsClientes
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsClientes
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>
                </mat-tab-group>
            </div>
            <!-- TABS fin -->
        </div>
        <!-- / CONTENT CARD -->
        </div>

    </mat-drawer-container>
</div>

<div class="page-layout carded fullwidth" *ngIf="!existeSujetoObligado">
    <!-- poner en el centro el usuario no tiene asociado un sujeto obligado-->
    <div class="center">
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Sujeto obligado</h2>
        </div>
        <div class="content-card">
            <div class="content p-24">
                <div class="profile-box info-box general" fxLayout="column">
                    <table class="summary">
                        <tr class="code">
                            <td class="value">
                                <span class="px-20">No tiene sujeto obligado asociado</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>